var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.206,
    height: 19.206,
    viewBox: "0 0 19.206 19.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "commerce-and-shopping (1)",
    d: "M9.6 0a9.6 9.6 0 1 0 9.6 9.6A9.614 9.614 0 0 0 9.6 0zm.625 15.3c-.456.076-1.364.266-1.825.3a1.124 1.124 0 0 1-.983-.512 1.2 1.2 0 0 1-.145-1.1L9.09 9H7.2a2.256 2.256 0 0 1 1.779-2.1 6.949 6.949 0 0 1 1.821-.3 1.447 1.447 0 0 1 .983.512 1.2 1.2 0 0 1 .145 1.1L10.116 13.2H12a2.125 2.125 0 0 1-1.776 2.1zM10.8 6A1.2 1.2 0 1 1 12 4.8 1.2 1.2 0 0 1 10.8 6z",
    style: {
      fill: "#ffd958"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowInfo);
export default __webpack_public_path__ + "static/media/yellow-info.04b58a3b4f08662450b4d9247a0ecfc9.svg";
export { ForwardRef as ReactComponent };